import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Alert } from 'react-bootstrap';

export default class RestartPlayerDialog extends Component {
  getInitialState = () => ({ confirm: false });

  state = this.getInitialState();

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { show } = nextProps;

    if (!show) {
      this.setState(this.getInitialState());
    }
  }

  onChangeConfirm = () => {
    const { confirm } = this.state;

    this.setState({ confirm: !confirm });
  };

  getDevices = () => {
    const { devices } = this.props;
    const names = devices.map((item, index) => (
      <li key={index}>
        <code>{item.name}</code> {item.description}
      </li>
    ));

    return <ol>{names}</ol>;
  };

  render() {
    const { show, onHide, onSuccess, devices } = this.props;
    const { confirm } = this.state;
    const plural = devices.length > 1 ? 's' : '';

    return (
      <Modal
        data-test="modal-restartplayer"
        dialogClassName="device-dialog"
        backdrop="static"
        show={show}
        onHide={onHide}
      >
        <Modal.Header>
          <Modal.Title data-test="modal-restartplayer-title">Restart Player</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Player{plural} to restart:</p>
          {this.getDevices()}
          <Alert bsStyle="warning">
            <label>
              <input
                data-test="modal-restartplayer-checkbox-confirm"
                type="checkbox"
                checked={confirm}
                onChange={this.onChangeConfirm}
              />{' '}
              I want to restart {devices.length} Player{plural}.
            </label>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={onHide}>
            Cancel
          </Button>
          <Button
            data-test="modal-restartplayer-button-restart"
            className="btn-add"
            bsStyle="primary"
            onClick={onSuccess}
            disabled={!confirm}
          >
            Restart Player{plural}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

RestartPlayerDialog.propTypes = {
  devices: PropTypes.array,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
